import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';
import { handleUnauthorized } from './auth-expiry';

// Audit-log endpoints (log-master, log-transactions, error-logs) live in the SAME
// local backend. Uses the shared local base; paths already include /api/v1/...
const AUDITLOG_API_BASE_URL =
  import.meta.env.VITE_AUDITLOG_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const auditlogApi: AxiosInstance = axios.create({
  baseURL: AUDITLOG_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
auditlogApi.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('accessToken');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
auditlogApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default auditlogApi;
